var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { useConsumers } from "../../provider";
import moment from "moment";
import { DeleteIcon, CopyIcon } from "../../assets/icons";
import "./styles.css";
var Error = function (_a) {
    var data = _a.data;
    var deleteErrorById = useConsumers().deleteErrorById;
    var _b = useState(false), copied = _b[0], setCopied = _b[1];
    var deleteError = useCallback(function () {
        if (data.id) {
            deleteErrorById(data.id);
        }
    }, [data.id, deleteErrorById]);
    var handleCopy = useCallback(function () {
        var clipboardData = {
            title: data.title,
            message: data.message,
            date: moment(data.date).format("DD MMM YYYY HH:mm"),
        };
        if (data.data) {
            clipboardData.data = data.data;
        }
        navigator.clipboard.writeText(JSON.stringify(clipboardData));
        setCopied(true);
    }, [data]);
    return (_jsxs("div", __assign({ className: "rjsFEP3fs9_error" }, { children: [_jsx("div", { className: "rjsFEP3fs9_error_flag" }), _jsxs("div", __assign({ className: "rjsFEP3fs9_error_row" }, { children: [_jsx("div", __assign({ className: "rjsFEP3fs9_error_title_container" }, { children: _jsx("p", __assign({ className: "rjsFEP3fs9_error_title" }, { children: data.title })) })), _jsx("div", __assign({ className: "rjsFEP3fs9_error_button_container" }, { children: _jsx("button", __assign({ className: "rjsFEP3fs9_error_button", onClick: deleteError }, { children: _jsx(DeleteIcon, {}) })) }))] })), _jsx("div", __assign({ className: "rjsFEP3fs9_error_row" }, { children: _jsx("p", __assign({ className: "rjsFEP3fs9_error_message" }, { children: data.message.toString() })) })), _jsxs("div", __assign({ className: "rjsFEP3fs9_error_row" }, { children: [_jsx("div", __assign({ className: "rjsFEP3fs9_error_title_container" }, { children: _jsx("p", __assign({ className: "rjsFEP3fs9_error_date" }, { children: moment(data.date).format("DD MMM YYYY HH:mm") })) })), _jsx("div", __assign({ className: "rjsFEP3fs9_error_button_container" }, { children: _jsxs("div", __assign({ className: "rjsFEP3fs9_tooltip" }, { children: [_jsx("button", __assign({ className: "rjsFEP3fs9_error_button", onClick: handleCopy, onMouseLeave: function () {
                                        setCopied(false);
                                    } }, { children: _jsx(CopyIcon, {}) })), _jsx("span", __assign({ className: "rjsFEP3fs9_tooltip_text" }, { children: copied ? "Copied" : "Copy to clipboard" }))] })) }))] }))] })));
};
export default Error;
